export default class CommitStatus {
    renderCounter(issuesCount, issuesDiff) {
        return null;
    }
    renderLoading(isPullRequest, percentage) {
        return null;
    }
    renderAutoFixes(fixFilesCount) {
        return null;
    }
    renderStatusBadge(commitOptions, errorCount, warningCount, isCommitDone, isCommitTimedOut, isCommitMeetingThreshold, loading) {
        return null;
    }
}
